import React from 'react';
import { Button, Fieldset, Toasts, Tooltip } from '@fourthwall/components';
import * as S from './AdminTab.styled';
import { usePublishPlatformApp } from './hooks/usePublishPlatformApp';
import { useRefreshPlatformApp } from './hooks/useRefreshPlatformApp';
import { useUnpublishPlatformApp } from './hooks/useUnpublishPlatformApp';
export const AdminTab = ({ app }) => {
    const { publishPlatformApp, isLoading: isPublishLoading } = usePublishPlatformApp();
    const { unpublishPlatformApp, isLoading: isUnpublishLoading } = useUnpublishPlatformApp();
    const { refreshPlatformApp, isLoading: isRefreshLoading } = useRefreshPlatformApp();
    const handlePublish = () => {
        Toasts.notify('Published', { type: 'success' });
        publishPlatformApp([{ clientId: app.id }]);
    };
    const handleUnpublish = () => {
        Toasts.notify('Unpublished', { type: 'info' });
        unpublishPlatformApp([{ clientId: app.id }]);
    };
    const handleRefresh = () => {
        Toasts.notify('Syncing app data to Shop Renderer', { type: 'info' });
        refreshPlatformApp([{ clientId: app.id }]);
    };
    const isPublished = app.status === 'PUBLISHED';
    return (React.createElement(S.Container, null,
        React.createElement(Fieldset, null,
            React.createElement(Fieldset.Row, null,
                React.createElement(Fieldset.Item, null,
                    React.createElement(S.SectionLabel, null, "App Status"),
                    React.createElement(S.StatusInfo, null,
                        "Current status: ",
                        React.createElement("strong", null, app.status)))),
            React.createElement(Fieldset.Row, null,
                React.createElement(Fieldset.Item, null,
                    React.createElement(S.ButtonContainer, null,
                        isPublished ? (React.createElement(Button, { label: "Unpublish", appearance: "destructive", onClick: handleUnpublish, loading: isUnpublishLoading })) : (React.createElement(Button, { label: "Publish", appearance: "primary", onClick: handlePublish, loading: isPublishLoading })),
                        React.createElement(Tooltip, { reference: React.createElement(Button, { label: "Sync", appearance: "secondary", onClick: handleRefresh, loading: isRefreshLoading }) }, "Sync app data to Shop Renderer")))))));
};
